import { DOCUMENT } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  Inject,
  Input,
} from '@angular/core';
import { A11yService } from '@app/shared/services/a11y.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'dgx-skip-nav',
    templateUrl: './skip-nav.component.html',
    styleUrls: ['./skip-nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SkipNavComponent {
  public i18n = this.translateService.instant(['dgSkipNav_SkipMainNavigation']);

  @Input() public containerName?: string = 'main';
  @Input() public linkText?: string = this.i18n.dgSkipNav_SkipMainNavigation;

  constructor(
    private translateService: TranslateService,
    private a11yService: A11yService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  public skipToContainer(event: Event): void {
    event?.preventDefault();
    const container = this.document.getElementById(this.containerName);
    // focusable includes links and other elements that did not
    // explicitly set a tabindex, so use focusable
    this.a11yService.focusNextFocusable(container);
  }
}
